import { createSelector } from 'reselect';
import { getFormValues, isInvalid } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import { initialState } from './reducer';
import { FORM_NAME } from './constants';

export const selectCargoExpressDeliveryModalDomain = state => state.cargoExpressDeliveryModalReducer || initialState;

export const selectRouterDomain = state => state.router || {};

export const getIsReqInfoLoadingSelector = () =>
	createSelector(selectCargoExpressDeliveryModalDomain, ({ isReqInfoLoading }) => isReqInfoLoading);

export const getIsReqInfoSendingSelector = () =>
	createSelector(selectCargoExpressDeliveryModalDomain, ({ isFormSending }) => isFormSending);

export const getReqInfoSelector = () =>
	createSelector(selectCargoExpressDeliveryModalDomain, ({ reqInfo }) => {
		return reqInfo;
	});

export const getIsModalShownSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'cargo_express_delivery');
	});

export const getActiveReqIdSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return query?.modal === 'cargo_express_delivery' ? query?.id : null;
	});

export const getFormValuesSelector = () =>
	createSelector(getFormValues(FORM_NAME), formValues => {
		const points = [];

		if (formValues?.points) {
			formValues.points.forEach((point, key) => {
				if (point) points.push(key);
			});
		}

		return {
			done_at: formValues?.done_at,
			points,
		};
	});

export const getFormIsInvalidSelector = () => createSelector(isInvalid(FORM_NAME), isInvalid => isInvalid);
